import { useState } from 'react';
import { cooperationTypes, partnerCases } from '../../mocks/partnersData';

export default function PartnersPage() {
  const [showContactForm, setShowContactForm] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#2A7A62] to-[#3D9B7F] text-white py-24">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-6">爱心企业光荣榜</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              感谢每一位爱心企业的支持与信任，让我们携手为一线工作者送去温暖与关怀
            </p>
          </div>
        </div>
      </section>

      {/* Cooperation Types */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">企业合作形式</h2>
            <p className="text-lg text-gray-600">多种合作方式，共同践行企业社会责任</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {cooperationTypes.map((type) => (
              <div
                key={type.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-[#2A7A62] to-[#3D9B7F] rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${type.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{type.title}</h3>
                <p className="text-gray-600 leading-relaxed">{type.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partner Cases */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">合作企业案例</h2>
            <p className="text-lg text-gray-600">他们用实际行动诠释企业担当</p>
          </div>

          <div className="grid md:grid-cols-2 gap-10">
            {partnerCases.map((partner) => (
              <div
                key={partner.id}
                className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={partner.photo}
                    alt={partner.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 right-4 bg-white rounded-xl px-4 py-2 shadow-lg">
                    <span className="text-[#2A7A62] font-bold">{partner.amount}</span>
                  </div>
                </div>

                <div className="p-8">
                  <div className="flex items-center gap-6 mb-6">
                    <div className="w-24 h-24 bg-white rounded-xl p-3 shadow-md flex items-center justify-center flex-shrink-0">
                      <img
                        src={partner.logo}
                        alt={`${partner.name} Logo`}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">{partner.name}</h3>
                      <div className="flex items-center gap-2 text-[#F4B942]">
                        <i className="ri-medal-line text-xl"></i>
                        <span className="font-semibold">{partner.impact}</span>
                      </div>
                    </div>
                  </div>

                  <p className="text-gray-700 leading-relaxed">{partner.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="relative bg-gradient-to-r from-[#2A7A62] via-[#3D9B7F] to-[#2A7A62] rounded-3xl p-12 text-center overflow-hidden shadow-2xl">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
            
            <div className="relative z-10">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-5xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-white mb-4">成为爱心伙伴</h2>
              <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
                携手点滴公益，共同为一线工作者送去关怀，提升企业社会责任形象
              </p>
              <button
                onClick={() => setShowContactForm(true)}
                className="bg-white text-[#2A7A62] px-10 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap inline-flex items-center gap-3"
              >
                <span>填写合作意向</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Modal */}
      {showContactForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-6">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex items-center justify-between">
              <h3 className="text-2xl font-bold text-gray-900">企业合作意向表</h3>
              <button
                onClick={() => setShowContactForm(false)}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <form className="p-8 space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  企业名称 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A7A62] focus:border-transparent outline-none transition-all"
                  placeholder="请输入企业全称"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    联系人 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A7A62] focus:border-transparent outline-none transition-all"
                    placeholder="请输入联系人姓名"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    联系电话 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A7A62] focus:border-transparent outline-none transition-all"
                    placeholder="请输入联系电话"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  合作形式 <span className="text-red-500">*</span>
                </label>
                <select
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A7A62] focus:border-transparent outline-none transition-all"
                >
                  <option value="">请选择合作形式</option>
                  <option value="strategic">战略合作</option>
                  <option value="material">物资支持</option>
                  <option value="procurement">公益采购</option>
                  <option value="other">其他形式</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  合作意向说明
                </label>
                <textarea
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A7A62] focus:border-transparent outline-none transition-all resize-none"
                  placeholder="请简要描述您的合作意向和期望..."
                  maxLength={500}
                ></textarea>
                <div className="text-right text-sm text-gray-500 mt-1">最多500字</div>
              </div>

              <button
                type="submit"
                className="w-full bg-[#2A7A62] text-white py-4 rounded-lg font-bold hover:bg-[#236B54] transition-colors whitespace-nowrap"
              >
                提交合作意向
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}